var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mv-iframe-container"},[_c('iframe',{staticClass:"mv-iframe-responsive",attrs:{"width":"100%","height":"600","src":_vm.facebookLiveUrl(),"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }